/**
 * SOLID Review
 * S — Strong. One concern: hold the session's account, screen, funnel fields, consent, ad config and video
 *     chat for the client view, written only through `ClientState`.
 * O — Good. A new session field is one member of `IStateSessionHost` and one value in `emptySessionHost`.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. Data only.
 * D — Strong. zustand, and the Application's session-host type and starting data.
 */
import { create } from 'zustand';
import { emptySessionHost } from '../../application/state/emptyClientState';
import type { IStateSessionHost } from '../../application/state/sessionStoreTypes';

/**
 * THE AUTH STORE, INSIDE INFRASTRUCTURE (frontend strict-ports plan, FE6c, 2026-10-04). It held the JWT and
 * wrote it to storage, kept the guest identity and carried a dozen actions the auth screens called, until
 * FE3 made each a decision or an Infrastructure concern (the JWT is `infrastructure/storage/
 * sessionTokenStorage.ts`'s, read only by Infrastructure; the store says `registered`). FE4c took its last
 * two actions. FE6c moves it beside the game store and types it by the Application's `IStateSessionHost`
 * — the interface `ClientState` wraps — instead of a copy of it (`IStateAuth` and its `AuthScreen`, deleted).
 */
export const useAuthStore = create<IStateSessionHost>(() => emptySessionHost());
